import React, { Component } from "react";
import "./Header.css";
import { Fade } from "../reveal/Fade";
import { NavLink, Link } from "react-router-dom";
import { greeting, settings } from "../../portfolio.js";
import SeoHeader from "../seoHeader/SeoHeader";
import { ThemeToggleContext } from "../../themeContext";

const SunIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="4.5" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

const MoonIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const onMouseEnter = (event, color) => {
  const el = event.target;
  el.style.backgroundColor = color;
};

const onMouseOut = (event) => {
  const el = event.target;
  el.style.backgroundColor = "transparent";
};

// "#RRGGBB" -> "rgba(r, g, b, a)" : fond translucide du header fixe
const withAlpha = (hex, alpha) => {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i.exec(hex || "");
  if (!m) return hex;
  const [r, g, b] = m.slice(1).map((h) => parseInt(h, 16));
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

class Header extends Component {
  static contextType = ThemeToggleContext;

  state = { scrolled: false };

  componentDidMount() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  // Ombre sous le header seulement une fois la page défilée
  onScroll = () => {
    const scrolled =
      (window.pageYOffset || document.documentElement.scrollTop) > 8;
    if (scrolled !== this.state.scrolled) this.setState({ scrolled });
  };

  render() {
    const theme = this.props.theme;
    const link = settings.isSplash ? "/splash" : "home";
    const { isDark, toggleTheme } = this.context;
    const toggleLabel = isDark
      ? "Activer le thème clair"
      : "Activer le thème sombre";
    return (
      <div
        className={
          this.state.scrolled ? "header-bar header-bar--scrolled" : "header-bar"
        }
        style={{
          backgroundColor: this.state.scrolled
            ? withAlpha(theme.body, 0.82)
            : withAlpha(theme.body, 0),
        }}
      >
        <Fade top duration={1000} distance="20px">
          <SeoHeader />
          <div>
            <header className="header">
              <NavLink to={link} tag={Link} className="logo">
                <span style={{ color: theme.text }}> &lt;</span>
                <span className="logo-name" style={{ color: theme.text }}>
                  {greeting.logo_name}
                </span>
                <span style={{ color: theme.text }}>/&gt;</span>
              </NavLink>
              <input className="menu-btn" type="checkbox" id="menu-btn" />
              <label className="menu-icon" htmlFor="menu-btn">
                <span className="navicon"></span>
              </label>
              {/* Avant .menu dans le DOM pour flotter près du burger sur mobile ;
                replacé après le menu sur desktop via `order`. */}
              <button
                type="button"
                className="theme-toggle"
                onClick={toggleTheme}
                aria-label={toggleLabel}
                title={toggleLabel}
                style={{ color: theme.text, borderColor: theme.headerColor }}
              >
                {isDark ? <SunIcon /> : <MoonIcon />}
              </button>
              <ul className="menu">
                <li>
                  <NavLink
                    to="/home"
                    tag={Link}
                    activeStyle={{ fontWeight: "bold" }}
                    style={{ color: theme.text }}
                    onMouseEnter={(event) =>
                      onMouseEnter(event, theme.highlight)
                    }
                    onMouseOut={(event) => onMouseOut(event)}
                  >
                    Accueil
                  </NavLink>
                </li>
                {/* <li>
                <NavLink
                  to="/education"
                  tag={Link}
                  activeStyle={{ fontWeight: "bold" }}
                  style={{ color: theme.text }}
                  onMouseEnter={(event) => onMouseEnter(event, theme.highlight)}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  Parcours académique
                </NavLink>
              </li> */}
                <li>
                  <NavLink
                    to="/experience"
                    tag={Link}
                    activeStyle={{ fontWeight: "bold" }}
                    style={{ color: theme.text }}
                    onMouseEnter={(event) =>
                      onMouseEnter(event, theme.highlight)
                    }
                    onMouseOut={(event) => onMouseOut(event)}
                  >
                    Parcours professionnel
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/projects"
                    tag={Link}
                    activeStyle={{ fontWeight: "bold" }}
                    style={{ color: theme.text }}
                    onMouseEnter={(event) =>
                      onMouseEnter(event, theme.highlight)
                    }
                    onMouseOut={(event) => onMouseOut(event)}
                  >
                    Réalisations
                  </NavLink>
                </li>
                {/* <li>
                <NavLink
                  to="/opensource"
                  tag={Link}
                  activeStyle={{ fontWeight: "bold" }}
                  style={{ color: theme.text }}
                  onMouseEnter={(event) => onMouseEnter(event, theme.highlight)}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  Open Source
                </NavLink>
              </li> */}
                <li>
                  <NavLink
                    to="/contact"
                    tag={Link}
                    activeStyle={{ fontWeight: "bold" }}
                    style={{ color: theme.text }}
                    onMouseEnter={(event) =>
                      onMouseEnter(event, theme.highlight)
                    }
                    onMouseOut={(event) => onMouseOut(event)}
                  >
                    Me contacter
                  </NavLink>
                </li>
              </ul>
            </header>
          </div>
        </Fade>
      </div>
    );
  }
}
export default Header;
